"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoveoFieldsHandler_1 = require("../../handlers/CoveoFieldsHandler");
var CoveoLabelsHandler_1 = require("../../handlers/CoveoLabelsHandler");
var Prebinding_1 = require("../Prebinding");
var PrebindHelpers_1 = require("../../resolvers/prebinding/PrebindHelpers");
var coveo_search_ui_1 = require("coveo-search-ui");
var ContextInitializer = (function () {
    function ContextInitializer() {
    }
    ContextInitializer.prototype.createFieldsHandler = function (options) {
        var externalFields = typeof (options.externalFields) !== "undefined" ? JSON.parse(options.externalFields) : [];
        return new CoveoFieldsHandler_1.CoveoFieldsHandler(externalFields, options.prefix, options.suffix);
    };
    ContextInitializer.prototype.createLabelsHandler = function (options) {
        var labels = typeof (options.labels) !== "undefined" ? JSON.parse(options.labels) : {};
        return new CoveoLabelsHandler_1.CoveoLabelsHandler(labels);
    };
    ContextInitializer.prototype.initializePrebinding = function (args) {
        PrebindHelpers_1.PrebindHelpers.getAllPrebindHelpers().forEach(function (helper) {
            Prebinding_1.Prebinding.registerPrebindHelper(helper.name, helper.getPrebind(args));
        });
    };
    ContextInitializer.prototype.initializeUnderscoreFieldsHelpers = function (fieldsHandler) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("coveoFieldValue", function (fieldName) {
            return this.raw[fieldsHandler.toCoveo(fieldName)];
        });
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("coveoFieldName", function (fieldName) {
            return fieldsHandler.toCoveo(fieldName);
        });
    };
    ContextInitializer.prototype.initializeUnderscoreLabelsHelpers = function (labels) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("translateLabel", function (labelKey) {
            return labels.translate(labelKey);
        });
    };
    ContextInitializer.prototype.initializeUnderscoreContextHelpers = function (sourceName) {
        coveo_search_ui_1.TemplateHelpers.registerTemplateHelper("currentSourceName", function () {
            return sourceName;
        });
    };
    ContextInitializer.prototype.initializeContextElement = function (contextElement) {
        Prebinding_1.Prebinding.applyPrebindingOnElement(contextElement);
    };
    return ContextInitializer;
}());
exports.ContextInitializer = ContextInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/ContextInitializer.ts
// module id = 29
// module chunks = 13 14